import { jsxs as c, jsx as n } from "react/jsx-runtime";
import { d as R } from "../../tslib.es6-CH0JWuEm.mjs";
import { Text as f, Spacer as _ } from "@zapier/design-system";
import H from "../MediaSlideshow/MediaSlideshow.es.js";
import { TemplateCTAs as S } from "../TemplateCTAs/TemplateCTAs.es.js";
import { ZapBreakdown as B } from "../ZapBreakdown/ZapBreakdown.es.js";
import { Z as w } from "../../ZapBreakdownSkeleton-BAGrHqZG.mjs";
const L = "_heroContent_164yb_1", M = "_modal_164yb_11", A = "_heroContentLeft_164yb_15", D = "_title_164yb_18", I = "_modalTitle_164yb_24", x = "_heroContentRight_164yb_30", N = "_modalHeroContentRight_164yb_61", P = "_pageHeroContentRight_164yb_65", e = {
  heroContent: L,
  modal: M,
  heroContentLeft: A,
  title: D,
  modalTitle: I,
  heroContentRight: x,
  modalHeroContentRight: N,
  pageHeroContentRight: P
};
var J = function(t) {
  var l, s, d, o = t.template, p = t.isLoggedIn, C = p === void 0 ? !1 : p, h = t.isDraftModeEnabled, u = h === void 0 ? !1 : h, a = t.zapBreakdownDetails, g = t.isModal, r = g === void 0 ? !1 : g, y = t.tryTemplateActions, T = t.templateBookmarkActions, b = t.hasBookmarking, k = t.hasTemplatePage, v = !((l = o.previewImage) === null || l === void 0) && l.url ? R([
    {
      type: "image",
      src: o.previewImage.url,
      alt: o.previewImage.alt
    }
  ], (d = (s = o.additionalMedia) === null || s === void 0 ? void 0 : s.filter(function(i) {
    return !!i.url;
  }).map(function(i) {
    var m;
    return {
      type: !((m = i.mimeType) === null || m === void 0) && m.includes("image") ? "image" : "video",
      src: i.url,
      alt: i.alt
    };
  })) !== null && d !== void 0 ? d : [], !0) : [];
  return /* @__PURE__ */ c("div", { className: "".concat(e.heroContent, " ").concat(r ? e.modal : ""), children: [
    /* @__PURE__ */ c("div", { className: e.heroContentLeft, children: [
      /* @__PURE__ */ c(f, { tag: "h1", type: r ? "SectionHeader" : "PageHeader", className: r ? e.modalTitle : e.title, children: [
        o.name,
        " ",
        u && "(Draft)"
      ] }),
      /* @__PURE__ */ n(_, { height: 16 }),
      /* @__PURE__ */ n(f, { tag: "p", type: "Body1Multiline", color: "TextDefault", children: o.subtitle }),
      o.subtitle && /* @__PURE__ */ n(_, { height: 20 }),
      /* @__PURE__ */ n(S, { template: o, isLoggedIn: C, templateBookmarkActions: T, hasBookmarking: b, tryTemplateActions: y, hasTemplatePage: k })
    ] }),
    /* @__PURE__ */ n("div", { className: r ? "".concat(e.modalHeroContentRight, " ").concat(e.heroContentRight) : "".concat(e.pageHeroContentRight, " ").concat(e.heroContentRight), children: v.length > 0 ? /* @__PURE__ */ n(H, { mediaItems: v }) : a ? /* @__PURE__ */ n(B, { title: a.title, firstStep: a.firstStep, lastStep: a.lastStep, totalStepCount: a.totalStepCount, services: a.services, servicesList: a.servicesList }) : /* @__PURE__ */ n(w, {}) })
  ] });
};
export {
  J as TemplateHeroSection
};
//# sourceMappingURL=TemplateHeroSection.es.js.map
